import React from 'react';
import { publicAssetsPrefix } from '../../../../../../configuration';

export default function OffersNotAvailable() {
  const { getText } = Pollfish.ui;
  const hideImage = Pollfish.helper.whiteLabelEnabled();
  return (
    <div className="main-content__home loading">
      <div className="loading__header" data-testid="end-screen-text">
        <h1>{getText('thank_you.no_offers_available.title')}</h1>
        <p>{getText('thank_you.no_offers_available.subtitle')}</p>
      </div>
      {!hideImage && (
        <div className="loading__image-container">
          <img
            src={`${publicAssetsPrefix}/img/orca.png`}
            alt="There is no survey available"
            className="loading__image"
          />
        </div>
      )}
      <p className="margin-reset">
        {getText('offerwall.offers.not_found.title')}
      </p>
      <p>{getText('offerwall.offers.not_found.subtitle')}</p>
      <div className="loading__submit-btn"></div>
    </div>
  );
}
